import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const useMenuChucNang = () => {
    const { webUrls, webChucNangs, webChucNangAll, loading, error } = useSelector((state: RootState) => state.menu);

    const hasMenu = (urlPath: string): boolean => {
        return webUrls.includes(urlPath);
    };

    const hasChucNang = (urlPath: string, chucNangCode: string): boolean => {
        // Nếu webChucNangs rỗng nhưng webChucNangAll có dữ liệu, sử dụng webChucNangAll
        if (webChucNangs.length === 0 && webChucNangAll.length > 0) {
            return webChucNangAll.includes(chucNangCode);
        }

        // Logic cũ nếu webChucNangs có dữ liệu
        const tabData = webChucNangs.find((item: { url: string; chucNangs: string[] }) => {
            return item.url === urlPath;
        });

        return tabData ? tabData.chucNangs.includes(chucNangCode) : false;
    };

    const getChucNangsByTab = (urlPath: string): string[] => {
        const tabData = webChucNangs.find((item: { url: string; chucNangs: string[] }) => item.url === urlPath);
        return tabData ? tabData.chucNangs : [];
    };

    const hasChucNangByCode = (chucNangCode: string): boolean => {
        return webChucNangAll.includes(chucNangCode);
    };


    return {
        webUrls,
        webChucNangs,
        webChucNangAll,
        loading,
        error,
        hasMenu,
        hasChucNang,
        getChucNangsByTab,
        hasChucNangByCode,
    };
}; 